import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { setCredentials } from '../../store/authSlice';
import { adminLogin } from '../../api/auth.api';
import AuthLayout from '../../layouts/AuthLayout';
import Input from '../../components/common/Input';
import Button from '../../components/common/Button';
import Alert from '../../components/common/Alert';

const AdminLogin = () => {
  const [form, setForm] = useState({ email: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await adminLogin(form);
      dispatch(setCredentials({ token: res.data.token, user: res.data.user }));
      navigate('/admin/dashboard');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout>
      <div className="mb-7">
        <div className="inline-flex items-center gap-2 bg-primary-50 text-primary-700 px-3 py-1 rounded-full text-xs font-semibold mb-3">
          <svg className="w-3.5 h-3.5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z" clipRule="evenodd" />
          </svg>
          Admin Access
        </div>
        <h2 className="text-2xl font-bold text-slate-900 leading-tight">Welcome back</h2>
        <p className="text-slate-500 text-sm mt-1">Sign in to your admin account to continue</p>
      </div>

      {error && <Alert type="error" className="mb-5">{error}</Alert>}

      <form onSubmit={handleSubmit} className="space-y-1">
        <Input
          label="Email address"
          type="email"
          placeholder="admin@company.com"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          required
        />
        <Input
          label="Password"
          type="password"
          placeholder="Enter your password"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          required
        />
        <div className="pt-2">
          <Button type="submit" fullWidth size="lg" loading={loading}>
            {loading ? 'Signing in…' : 'Sign In'}
          </Button>
        </div>
      </form>

      <p className="text-center text-sm text-slate-400 mt-4">
        <a href="/admin/forgot-password" className="text-primary-600 hover:text-primary-700 font-medium hover:underline">
          Forgot password?
        </a>
      </p>
      <p className="text-center text-sm text-slate-400 mt-2">
        Candidate?{' '}
        <a href="/login" className="text-primary-600 hover:text-primary-700 font-medium hover:underline">
          Candidate Login
        </a>
      </p>
    </AuthLayout>
  );
};

export default AdminLogin;
